<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="入库单"
      edit-title
      id-key="RecordId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="box-header">基础信息</div>
        <div class="box">
          <el-row>
            <el-col :span="isMB ? 24 : 8">
              <el-form-item label="入库单号" prop="IndocCode">
                <!-- <el-input v-model="data.IndocCode" placeholder="请输入入库单号"></el-input> -->
                <span v-if="data.RecordId == 0">自动生成</span>
                <span v-else>{{ data.IndocCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 8">
              <el-form-item label="入库日期" prop="IndocDate">
                <el-date-picker
                  v-model.trim="data.IndocDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="isMB ? 24 : 8" v-if="loginInfo.UserType == 0">
              <el-form-item label="所属商家" prop="StoreId">
                <busi-select
                  v-model="data.StoreId"
                  ref="busiSelect"
                  :checkState="checkState"
                ></busi-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="isMB ? 24 : 8">
              <el-form-item label="入库仓库" prop="WhId">
                <el-select
                  v-model="data.WhId"
                  placeholder="请选择入库仓库"
                  clearable
                  @change="changeWh"
                >
                  <el-option
                    v-for="(i, k) in whs"
                    :key="k"
                    :label="i.WhName"
                    :value="i.RecordId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="box-header">
          <span>入库明细</span>
          <div v-if="$permission.canEdit()">
            <el-button type="primary" @click="addGoods">添加</el-button>
            <el-button type="danger" @click="delGoods">删除</el-button>
          </div>
        </div>
        <el-table
          border
          :data="data.Goods"
          highlight-current-row
          @selection-change="onSelectGoods"
        >
          <el-table-column type="selection" width="35" />
          <el-table-column prop="GoodsName" label="商品名称" min-width="260px">
            <!-- <template slot-scope="{ row }">
              <goods-select
                v-model="row.GoodsName"
                :source="goods"
                @select="onSetGoods($event, row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal"
                @currentPage="currentPage($event, row)"
                @click.native="resetFun"
                @inputText="inputText($event, row)"
                :pageType="true"
              /> -->
            <!--:source="goods"就是指定选择界面显示的数据来源-->
            <!-- </template> -->
          </el-table-column>
          <el-table-column
            prop="GoodsCode"
            label="商品编码"
            min-width="110px"
          />
          <el-table-column
            prop="AttributeName"
            label="规格型号"
            min-width="110px"
          />
          <el-table-column
            prop="AttributeCode"
            label="货号"
            min-width="110px"
          />
          <el-table-column prop="TypeName" label="商品分类" min-width="110px" />
          <!--   <el-table-column prop="GoodsModel" label="" min-width="100px" />-->
          <el-table-column prop="MainUnitName" label="单位" min-width="80px" />
          <el-table-column prop="InCount" label="数量" min-width="100px">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.InCount"
                v-int
                @input="onInput(row, 'InCount')"
                placeholder="输入数量"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="InPrice" label="单价" min-width="100px">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.InPrice"
                v-snum
                @input="onInput(row, 'InPrice')"
                placeholder="输入单价"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="InAmount" label="金额" min-width="100px" />
        </el-table>
      </template>
      <template slot="footer">
        <el-button
          type="primary"
          @click="onSave(0)"
          v-if="$permission.canEdit()"
          >保 存</el-button
        >
        <el-button
          type="success"
          @click="onSave(1)"
          v-if="$permission.canEdit()"
          >提 交</el-button
        >
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :sameBusiness="true"
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>

<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import goodsSelect from "@/components/goods/goodsattribute/select";
import storeSelect from "@/components/shop/store/select";
import busiSelect from "@/components/shop/business/select";
import goodsDialog from "@/components/goods/info/listDialogmul";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    goodsSelect,
    storeSelect,
    busiSelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        IndocCode: "",
        IndocDate: this.$commonJs.getToday(),
        WhId: null, //仓库
        State: 0, //0草稿，1待审，2通过，3不通过，4作废
        Goods: [],
        StoreId: null,
      },
      DelGoods: [],
      whs: [], //仓库列表
      selectGoods: [],
      api: require("@/api/wh/indoc").default,
      whApi: require("@/api/wh/base").default,
      goodsattributeApi: require("@/api/goods/goodsattribute").default,
      isMB: this.$store.state.isMB,
      rules: {
        // IndocCode: [{ required: true, message: "入库单号不能为空" }],
        IndocDate: [{ required: true, message: "入库日期不能为空" }],
        WhId: [{ required: true, message: "请选择仓库" }],
      },
      goods: [], //商品列表
      initGoods: [],
      listTotal: 0,
      initTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      checkState: 2,
    };
  },
  // watch: {
  //   "data.StoreId"(newVal, oldVal) {
  //     if (this.loginInfo.UserType == 0) {
  //       var storeId = null;
  //       if (newVal > 0) {
  //         storeId = newVal;
  //       } else {
  //         this.whs = [];
  //         this.initGoods = [];
  //         this.initTotal = 0;
  //       }
  //       if (storeId > 0) {
  //         this.goodsattributeApi
  //           .list({ State: 1, pageIndex: 1, pageSize: 7, StoreId: storeId })
  //           .then((res) => {
  //             if (res.Code == 0) {
  //               this.initGoods = this.goods = res.Data; //调用接口，把结果赋值给goods数组，就是显示可选商品和规格
  //               this.initTotal = this.listTotal = res.Count;
  //             }
  //           });
  //         this.whApi.list({ State: 1, StoreId: storeId }).then((res) => {
  //           if (res.Code == 0) this.whs = res.Data;
  //         });
  //       }
  //     }
  //   },
  // },
  methods: {
    changeWh() {
      if (this.data.Goods.length > 0) {
        this.data.Goods.forEach((item) => {
          if (item.T !== 0) item.T = 1;
        });
      }
    },
    onOpened() {
      this.whApi.list({ State: 1 }).then((res) => {
        if (res.Code == 0) this.whs = res.Data;
      });

      this.goodsattributeApi
        .list({
          State: 1,
          pageIndex: 1,
          pageSize: 7,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.initGoods = this.goods = res.Data; //调用接口，把结果赋值给goods数组，就是显示可选商品和规格
            this.initTotal = this.listTotal = res.Count;
          }
        });
    },
    onCreateOpened() {
      //this.addGoods();
    },
    onEditOpened(data) {
      this.data.Goods = data.Goods.map((x, i) => ({ ...x, Index: i, T: null }));
      console.log("data", this.data);
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.goods = this.initGoods;
      this.listTotal = this.initTotal;
    },
    currentPage(data, row) {
      var TradeMode = 0;
      if (this.loginInfo.UserType == 1) {
        TradeMode = 1;
      }
      var storeId = null;
      if (this.data.StoreId > 0) {
        storeId = this.data.StoreId;
      }
      this.pageParams.pageIndex = data.val;
      this.goodsattributeApi
        .list({
          State: 1,
          pageIndex: data.val,
          pageSize: 7,
          GoodsName: row.GoodsName,
          StoreId: storeId,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.goods = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.GoodsName = text;
      var TradeMode = 0;
      if (this.loginInfo.UserType == 1) {
        TradeMode = 1;
      }
      var storeId = null;
      if (this.data.StoreId > 0) {
        storeId = this.data.StoreId;
      }
      this.goodsattributeApi
        .list({
          State: 1,
          pageIndex: 1,
          pageSize: 7,
          GoodsName: text,
          StoreId: storeId,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.goods = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    onSetGoods(e, row) {
      console.log("商品", JSON.parse(JSON.stringify(e)));
      console.log("明细", JSON.parse(JSON.stringify(row)));

      if (
        this.data.Goods.some(
          (x) => x.GoodsId == e.GoodsId && x.AttributeId == e.RecordId
        )
      ) {
        this.$message.warning("已存在商品和规格型号相同的明细");
        return;
      }

      if (row.T !== 0) row.T = 1; //判断这条数据是否新增的，T==0就是新增的，不是0就需要改成1，因为T==1是修改。

      row.GoodsId = e.GoodsId;
      row.GoodsCode = e.GoodsCode;
      row.GoodsName = e.GoodsName;
      row.TypeName = e.TypeName;
      row.GoodsModel = e.GoodsModel;
      row.MainUnitName = e.MainUnitName;
      row.AttributeId = e.RecordId;
      row.AttributeName = e.AttributeName;
      row.AttributeCode = e.AttributeCode;
      console.log(row, "row");
    },
    onInput(row, type) {
      if (row.T !== 0) row.T = 1;

      if (row.InPrice) {
        var inPriceStr = row.InPrice.toString();
        row.InPrice = inPriceStr.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1");
      }

      var inCount = parseFloat(row.InCount);
      var inPrice = parseFloat(row.InPrice);
      if (!Number.isNaN(inCount) && !Number.isNaN(inPrice)) {
        row.InAmount = parseFloat((inCount * inPrice).toFixed(2));
      } else {
        row.InAmount = null;
      }
    },
    onSelectGoods(selection) {
      this.selectGoods = selection;
    },
    setGoods(data) {
      console.log("data", data);
      this.data.Goods = data.OrderGoods;
      this.data.Goods.forEach((x, i) => (x.Index = i));
      if (this.data.RecordId > 0) {
        this.data.Goods.forEach((x) => {
          x.IndocId = this.data.RecordId;
        });
      }
    },
    addGoods() {
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ OrderState: 1 });
      });
      // this.data.Goods.push({
      //   Index: this.data.Goods.length,
      //   RecordId: 0,
      //   IndocId: this.data.RecordId,
      //   OrderId: 0, //序号
      //   GoodsId: null, //商品
      //   GoodsCode: "", //商品编码
      //   GoodsName: "", //商品名称
      //   TypeName: "", //商品分类
      //   GoodsModel: "", //规格型号
      //   MainUnitName: "", //单位
      //   AttributeId: null, //属性
      //   AttributeName: "", //属性名称
      //   AttributeCode: "", //属性名称编码
      //   InCount: null, //入库数量
      //   InPrice: null, //入库单价
      //   InAmount: null, //入库金额
      //   T: 0,
      // });
    },
    delGoods() {
      if (this.selectGoods.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.selectGoods.forEach((x) => {
        if (x.T != 0) {
          this.DelGoods.push({ ...x, T: 2 });
        }
        var index = this.data.Goods.indexOf(x);
        this.data.Goods.splice(index, 1);
      });
      //清空选中的数据
      this.selectGoods = [];
      //对序号进行重新排序
      this.data.Goods.forEach((x, i) => {
        x.Index = i;
        x.OrderId = i;
        if (x.RecordId != 0) {
          x.T = 1;
        } else {
          x.T = 0;
        }
      });
    },
    onSave(type) {
      var formPromise = this.$refs.dialog.formValidate();
      formPromise.then((valid) => {
        if (!valid) {
          return;
        }
        if (this.data.Goods.length == 0) {
          this.$message.warning("入库明细不能为空");
          return;
        }

        if (this.data.Goods.some((x) => !x.GoodsId)) {
          this.$message.warning("请选择商品");
          return;
        }

        if (this.data.Goods.some((x) => !x.InCount)) {
          this.$message.warning("数量不能为空");
          return;
        }

        if (this.data.Goods.some((x) => !x.InPrice)) {
          this.$message.warning("单价不能为空");
          return;
        }

        var data = this.$commonJs.obj.removeNullKey(this.data);
        data.Goods = this.data.Goods.filter((x) => x.T != null);
        this.DelGoods.forEach((x) => data.Goods.push(x));

        console.log("save", JSON.parse(JSON.stringify(data)));

        var func = type == 0 ? this.api.save : this.api.submit;
        this.$refs.dialog.loading();
        func(data).then((res) => {
          this.$refs.dialog.loading(false);
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.close(true);
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.selectGoods = [];
      this.DelGoods = [];
      this.data.Goods = [];
      this.initGoods = [];
      this.goods = [];
      this.initTotal = 0;
    },
  },
};
</script>